// @ts-nocheck
document.addEventListener("DOMContentLoaded", () => {
  const carousels = document.querySelectorAll(".video-product-carousel");

  carousels.forEach((carousel) => {
    const wrapper = carousel.querySelector(".swiper-wrapper");
    const originalSlides = [...wrapper.querySelectorAll(".swiper-slide")];

    // Mark original slides AND set poster on wrapper before cloning
    originalSlides.forEach((slide) => {
      slide.setAttribute("data-original", "true");

      const video = slide.querySelector("video");
      const videoWrapper = slide.querySelector(".video-product-carousel__video-wrapper");
      if (video && videoWrapper) {
        const poster = video.getAttribute("poster");
        if (poster) {
          videoWrapper.style.backgroundImage = `url('${poster}')`;
          videoWrapper.style.backgroundSize = "cover";
          videoWrapper.style.backgroundPosition = "center";
        }
      }
    });

    const totalOriginal = originalSlides.length;

    if (totalOriginal > 0 && totalOriginal < 8) {
      originalSlides.forEach((slide) => {
        const clone = slide.cloneNode(true);
        clone.removeAttribute("data-original");
        clone.classList.add("swiper-slide--cloned");
        wrapper.appendChild(clone);
      });
    }

    const swiper = new Swiper(carousel, {
      slidesPerView: 1.3,
      centeredSlides: true,
      spaceBetween: 15,
      loop: true,
      preloadImages: true,
      updateOnImagesReady: true,
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      observer: true,
      observeParents: true,
      updateOnWindowResize: true,
      a11y: true,
      keyboard: { enabled: true, onlyInViewport: true },
      mousewheel: { forceToAxis: true },
      navigation: {
        nextEl: carousel.querySelector(".video-button-next"),
        prevEl: carousel.querySelector(".video-button-prev"),
      },
      pagination: {
        el: carousel.querySelector(".swiper-pagination"),
        clickable: true,
      },
      breakpoints: {
        0: { spaceBetween: 0, slidesPerView: 1.5 },
        525: { spaceBetween: 0, slidesPerView: 2.4 },
        769: { spaceBetween: 0, slidesPerView: 2.6 },
        890: { spaceBetween: 0, slidesPerView: 3.3 },
        1025: { spaceBetween: 0, slidesPerView: 3.9 },
        1200: { spaceBetween: 0, slidesPerView: 4.4 },
      },
      on: {
        init() { playActiveVideo(this); },
        slideChange() { playActiveVideo(this); },
      },
    });

    function playActiveVideo(swiper) {
      swiper.slides.forEach((slide) => {
        const video = slide.querySelector("video");
        if (video) {
          video.pause();
          video.currentTime = 0;
        }
      });

      const activeSlide = swiper.slides[swiper.activeIndex];
      const activeVideo = activeSlide?.querySelector("video");
      if (activeVideo) {
        activeVideo.play().catch(() => {});
        activeVideo.onended = () => swiper.slideNext();
      }
    }

    /* ---------------- MODAL ---------------- */
    const modal = document.querySelector(".video-product-carousel-modal");
    if (!modal) return;

    const modalVideo = modal.querySelector("video");
    const modalClose = modal.querySelector(".video-product-carousel-modal__close");
    let allSlides = [], currentIndex = 0;

    function isMobile() {
      return window.innerWidth < 768;
    }

    // Open modal on video click (mobile only)
    carousel.addEventListener("click", (e) => {
      const videoEl = e.target.closest(".video-product-carousel__video");
      if (!videoEl || !isMobile()) return;

      e.preventDefault();
      const slide = videoEl.closest(".swiper-slide");
      if (!slide || !slide.hasAttribute("data-original")) return;

      allSlides = Array.from(
        carousel.querySelectorAll('.swiper-slide[data-original="true"]'),
      );
      currentIndex = allSlides.indexOf(slide);

      openModal(videoEl);
    });

    function openModal(videoEl) {
      if (!modalVideo) return;

      modalVideo.src = videoEl.src;
      modalVideo.poster = videoEl.poster;
      modal.classList.add("active");
      document.body.classList.add("modal-open");

      muteAllCarouselVideos(carousel);

      modalVideo.load();
      modalVideo.onloadeddata = () => {
        modalVideo.currentTime = 0;
        modalVideo.muted = false;
        modalVideo.play().catch(() => {});
        syncMuteUI(modalVideo, true);
      };
    }

    function closeModal() {
      modal.classList.remove("active");
      document.body.classList.remove("modal-open");

      if (modalVideo) {
        modalVideo.pause();
        modalVideo.currentTime = 0;
        modalVideo.removeAttribute("src");
      }
    }

    function showModalVideoByIndex(idx) {
      if (idx < 0 || idx >= allSlides.length) return;
      const slide = allSlides[idx];
      const videoEl = slide.querySelector("video");
      if (!videoEl) return;

      currentIndex = idx;
      modalVideo.src = videoEl.src;
      modalVideo.poster = videoEl.poster;

      modalVideo.load();
      modalVideo.onloadeddata = () => {
        modalVideo.currentTime = 0;
        modalVideo.play().catch(() => {});
      };
    }

    /* --------- SWIPE (mobile next/prev) --------- */
    let touchStartY = null;
    modal.addEventListener("touchstart", (e) => {
      if (isMobile() && modal.classList.contains("active"))
        touchStartY = e.touches[0].clientY;
    });
    modal.addEventListener("touchend", (e) => {
      if (!isMobile() || !modal.classList.contains("active")) return;
      if (touchStartY == null) return;

      const deltaY = touchStartY - e.changedTouches[0].clientY;
      if (Math.abs(deltaY) > 50) {
        showModalVideoByIndex(currentIndex + (deltaY > 0 ? 1 : -1));
      }
      touchStartY = null;
    });

    /* --------- Modal controls --------- */
    modalClose?.addEventListener("click", closeModal);
    modal.addEventListener("click", (e) => {
      if (e.target === modal) closeModal();
    });
  });

  /* --------- Global mute toggle (delegated) --------- */
  document.body.addEventListener("click", (e) => {
    const btn = e.target.closest(".mute-toggle");
    if (!btn) return;

    const video = btn.closest(".video-product-mute")?.querySelector("video");
    if (!video) return;

    video.muted = !video.muted;
    syncMuteUI(video);
  });

  function syncMuteUI(video, forceUnmute = false) {
    const muteToggle = video
      .closest(".video-product-carousel-modal__video-wrapper, .video-product-mute")
      ?.querySelector(".mute-toggle");
    if (!muteToggle) return;
    muteToggle.querySelector(".icon-muted").style.display =
      video.muted && !forceUnmute ? "inline-flex" : "none";
    muteToggle.querySelector(".icon-unmuted").style.display =
      video.muted && !forceUnmute ? "none" : "inline-flex";
  }

  function muteAllCarouselVideos(carousel) {
    carousel.querySelectorAll("video").forEach((v) => {
      v.muted = true;
      syncMuteUI(v);
    });
  }
});